<template>
  <div
    class="header-menu-container"
    :style="hover === true ? { background: '#20202f61', height: '100vh' } : {}"
  >
    <div
      class="header-menu-wrapper"
      @mouseleave="hover = false"
      :class="
        hover
          ? tab === 'solutions'
            ? 'open-menu-solutions'
            : tab === 'individuals'
            ? 'open-menu-individuals'
            : 'open-menu-resources'
          : ''
      "
    >
      <div class="row header-align-items">
        <div class="col-8">
          <div class="header-menu-options-left">
            <img
              class="header-menu-image"
              :src="`${
                !hover
                  ? require('@/assets/images/logo.png')
                  : require('@/assets/images/logoColored.png')
              }`"
              alt="header logo image"
              @click="$router.push('/')"
            />
            <div
              class="header-menu-options-left header-flex-grow header-align-items header-desktop-menu-buttons"
            >
              <div
                class="header-menu-options"
                :class="hover ? 'open-menu-text' : ''"
                @click="$router.push('/spanish-courses-overview')"
              >
                Courses
              </div>
              <div
                class="header-menu-options"
                @mouseenter="
                  hover = true;
                  tab = 'individuals';
                "
              >
                <div :class="hover ? 'open-menu-text' : ''">
                  For Individuals <i class="mdi mdi-menu-down"></i>
                </div>
              </div>
              <div
                class="header-menu-options"
                @mouseenter="
                  hover = true;
                  tab = 'solutions';
                "
              >
                <div :class="hover ? 'open-menu-text' : ''">
                  For Organizations <i class="mdi mdi-menu-down"></i>
                </div>
              </div>
              <div
                class="header-menu-options"
                :class="hover ? 'open-menu-text' : ''"
                @click="$router.push('/spanish-course-pricing')"
              >
                Pricing
              </div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-menu-buttons">
            <md-outlined-button
              @click="openLink('comligospanish.com')"
              class="header-menu-left-button discover-more-button"
              :class="hover ? 'open-menu-button' : ''"
              >Login</md-outlined-button
            >
            <md-filled-tonal-button @click="$router.push('/book-demo')">
              Book Your Free Trial Now
              <i class="mdi mdi-arrow-right"></i>
            </md-filled-tonal-button>
          </div>
          <div
            :class="
              hover
                ? 'header-menu-mobile-icon-active'
                : 'header-menu-mobile-icon-inactive'
            "
            @click="
              hover = !hover;
              tab = 'resources';
            "
          >
            <i
              :class="`mdi ${
                !hover ? 'mdi-menu' : 'mdi-close'
              } menu-icon-header`"
            ></i>
          </div>
        </div>
      </div>
      <div class="header-menu-options-inner header-flex-grow" v-if="hover">
        <div
          class="header-menu-options"
          :class="hover ? 'open-menu-text' : ''"
          @click="$router.push('/spanish-courses-overview')"
        >
          Courses
        </div>
        <div
          class="header-menu-options"
          @mouseenter="
            hover = true;
            tab = 'solutions';
          "
        >
          <div
            class="open-menu-text"
            :class="tab === 'solutions' ? 'open-menu-text-active' : ''"
          >
            <div class="desktop-menu-options">
              For Individuals <i class="mdi mdi-menu-down"></i>
            </div>
            <v-list class="open-menu-list-item">
              <div v-for="item in individuals" :key="item.title">
                <v-list-group v-model="item.active" no-action>
                  <template v-slot:activator="{ props }">
                    <v-list-item
                      :append-icon="
                        item.active ? 'mdi-menu-up' : 'mdi-menu-down'
                      "
                      @click="item.active = !item.active"
                      v-bind="props"
                    >
                      <v-list-item-title
                        v-bind="props"
                        class="mobile-menu-item"
                        @click.stop="item.active = !item.active"
                        pre
                      >
                        {{ item.title }}
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                  <md-filled-tonal-button
                    class="menu-check-button"
                    @click="$router.push('/spanish-courses-overview')"
                  >
                    Check our courses
                    <i class="mdi mdi-arrow-right"></i>
                  </md-filled-tonal-button>
                  <v-list-item
                    v-for="(subItem, index) in item.items"
                    :key="index"
                  >
                    <v-list-item-title @click="$router.push(subItem.link)">
                      {{ subItem.title }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list-group>
              </div>
            </v-list>
          </div>
        </div>
        <div
          class="header-menu-options"
          @mouseenter="
            hover = true;
            tab = 'solutions';
          "
        >
          <div
            class="open-menu-text"
            :class="tab === 'solutions' ? 'open-menu-text-active' : ''"
          >
            <div class="desktop-menu-options">
              Solutions <i class="mdi mdi-menu-down"></i>
            </div>
            <v-list class="open-menu-list-item">
              <div v-for="item in solutions" :key="item.title">
                <v-list-group v-model="item.active" no-action>
                  <template v-slot:activator="{ props }">
                    <v-list-item
                      :append-icon="
                        item.active ? 'mdi-menu-up' : 'mdi-menu-down'
                      "
                      @click="item.active = !item.active"
                      v-bind="props"
                    >
                      <v-list-item-title
                        v-bind="props"
                        class="mobile-menu-item"
                        @click.stop="item.active = !item.active"
                        pre
                      >
                        {{ item.title }}
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                  <md-filled-tonal-button
                    class="menu-check-button"
                    @click="$router.push('/spanish-courses-overview')"
                  >
                    Check our courses
                    <i class="mdi mdi-arrow-right"></i>
                  </md-filled-tonal-button>
                  <v-list-item
                    v-for="(subItem, index) in item.items"
                    :key="index"
                  >
                    <v-list-item-title @click="$router.push(subItem.link)">
                      {{ subItem.title }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list-group>
              </div>
            </v-list>
          </div>
        </div>
        <div
          class="header-menu-options"
          :class="hover ? 'open-menu-text' : ''"
          @click="$router.push('/spanish-course-pricing')"
        >
          Pricing
        </div>
        <md-outlined-button
          @click="openLink('comligospanish.com')"
          class="header-menu-left-button discover-more-button sign-in-button"
          >Sign In</md-outlined-button
        >
        <md-filled-tonal-button
          class="get-started-button"
          @click="$router.push('/book-demo')"
        >
          Book Your Free Trial Now
          <i class="mdi mdi-arrow-right"></i>
        </md-filled-tonal-button>
      </div>
      <div v-if="hover && tab === 'solutions'" class="header-submenus">
        <div class="row">
          <div class="col-4 header-submenu-sections">
            <div class="header-submenu-title">Solutions</div>
            <div class="header-submenu-body">
              Discover our range of solutions tailored to meet your specific
              needs. Whether you are in education, the private or public sector,
              or just want to learn Spanish, our innovative tools and resources
              are designed to enhance efficiency, productivity, and success.
            </div>
            <md-filled-tonal-button
              class="header-menu-hover-button"
              @click="$router.push('/spanish-courses-overview')"
            >
              Check our courses
              <i class="mdi mdi-arrow-right"></i>
            </md-filled-tonal-button>
          </div>
          <div class="col-4 header-submenu-sections">
            <div
              class="header-submenu-title-links"
              @click="$router.push('/k-12-schools')"
            >
              For K-12 education
            </div>
            <div class="header-submenu-body">
              Tailored solutions to enhance teaching, learning, and
              administrative efficiency in K-12.
            </div>
            <div
              class="header-submenu-title-links"
              @click="$router.push('/ib-schools')"
            >
              For IB schools
            </div>
            <div class="header-submenu-body">
              Specialized solutions for managing IB curriculum, assessments, and
              educator support.
            </div>
            <div
              class="header-submenu-title-links"
              @click="$router.push('/private-sector')"
            >
              For private sector
            </div>
            <div class="header-submenu-body">
              Comprehensive solutions for project management, customer
              relations, and operational efficiency.
            </div>
          </div>
          <div class="col-4 header-submenu-sections">
            <div
              class="header-submenu-title-links"
              @click="$router.push('/higher-education')"
            >
              For higher education
            </div>
            <div class="header-submenu-body">
              Advanced solutions for academic management, research
              collaboration, and student engagement.
            </div>
            <div
              class="header-submenu-title-links"
              @click="$router.push('/public-sector-ngos')"
            >
              For public sector and non-profits
            </div>
            <div class="header-submenu-body">
              Efficient solutions for management, reporting, and communication
              in public service and non-profits.
            </div>
            <div
              class="header-submenu-title-links"
              @click="$router.push('/curriculum')"
            >
              Purchase curriculums
            </div>
            <div class="header-submenu-body">
              Comprehensive solutions for project management, customer
              relations, and operational efficiency.
            </div>
          </div>
        </div>
      </div>
      <div v-if="hover && tab === 'resources'" class="header-submenus">
        <div class="row">
          <div class="col-4 header-submenu-sections">
            <div class="header-submenu-title">Resources</div>
            <div class="header-submenu-body">
              Explore our collection of valuable resources designed to support
              your growth and success. From insightful articles to comprehensive
              guides, eBooks, and events, we provide the tools and knowledge you
              need to excel.
            </div>
            <md-filled-tonal-button
              class="header-menu-hover-button"
              @click="$router.push('/spanish-learning-resources')"
            >
              Check our resources
              <i class="mdi mdi-arrow-right"></i>
            </md-filled-tonal-button>
          </div>
          <div class="col-4 header-submenu-sections">
            <div
              class="header-submenu-title-links"
              @click="$router.push('/spanish-learning-articles')"
            >
              Articles
            </div>
            <div class="header-submenu-body">
              Access expert-written articles on industry trends, best practices,
              and innovative solutions.
            </div>
            <div
              class="header-submenu-title-links"
              @click="$router.push('/spanish-learning-ebooks')"
            >
              eBooks
            </div>
            <div class="header-submenu-body">
              Explore our library of eBooks, offering detailed insights and
              practical advice on various subjects.
            </div>
          </div>
          <div class="col-4 header-submenu-sections">
            <div
              class="header-submenu-title-links"
              @click="$router.push('/comligo-spanish-events')"
            >
              Events
            </div>
            <div class="header-submenu-body">
              Stay informed about upcoming events, webinars, and workshops to
              enhance your skills and network.
            </div>
            <div
              class="header-submenu-title-links"
              @click="$router.push('/spanish-case-studies')"
            >
              Case studies
            </div>
            <div class="header-submenu-body">
              Discover our success stories showcasing real-world applications,
              measurable results, and impactful strategies tailored to diverse
              industries.
            </div>
          </div>
        </div>
      </div>
      <div v-if="hover && tab === 'individuals'" class="header-submenus">
        <div class="row">
          <div class="col-4 header-submenu-sections">
            <div class="header-submenu-title">For Individuals</div>
            <div class="header-submenu-body">
              Discover our range of solutions tailored to meet your specific
              needs. Whether you are in education, the private sector, or the
              public sector, our innovative tools and resources are designed to
              enhance efficiency, productivity, and success.
            </div>
            <md-filled-tonal-button
              class="header-menu-hover-button"
              @click="$router.push('/spanish-courses-overview')"
            >
              Check our courses
              <i class="mdi mdi-arrow-right"></i>
            </md-filled-tonal-button>
          </div>
          <div class="col-4 header-submenu-sections">
            <div
              class="header-submenu-title-links"
              @click="$router.push('/for-professionals')"
            >
              For Professionals
            </div>
            <div class="header-submenu-body">
              Enhance your communication skills, expand your global
              opportunities, and gain confidence in business interactions.
            </div>
            <div
              class="header-submenu-title-links"
              @click="$router.push('/for-heritage-speakers')"
            >
              For Heritage Learners
            </div>
            <div class="header-submenu-body">
              If Spanish is part of your heritage, but fluency feels out of
              reach, our courses help you rediscover the language and culture in
              a way that feels natural and meaningful.
            </div>
          </div>
          <div class="col-4 header-submenu-sections">
            <div
              class="header-submenu-title-links"
              @click="$router.push('/for-parents')"
            >
              For Young Learners
            </div>
            <div class="header-submenu-body">
              Specialized solutions for managing IB curriculum, assessments, and
              educator support.
            </div>
            <div
              class="header-submenu-title-links"
              @click="$router.push('/for-individuals')"
            >
              For Leisure & Travel
            </div>
            <div class="header-submenu-body">
              Planning a trip? Learn practical phrases, cultural etiquette, and
              essential vocabulary to navigate Spanish-speaking countries with
              ease.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderMenu",
  data() {
    return {
      hover: false,
      tab: "",
      solutions: [
        {
          title: "For Organizations",
          items: [
            {
              title: "For K-12 education",
              link: "/k-12-schools",
            },
            {
              title: "For IB schools",
              link: "/ib-schools",
            },
            {
              title: "For private sector",
              link: "/private-sector",
            },
            {
              title: "For higher education",
              link: "/higher-education",
            },
            {
              title: "For public sector and non-profits",
              link: "/public-sector-ngos",
            },
            {
              title: "Purchase curriculums",
              link: "/curriculum",
            },
          ],
          link: "",
          icon: "mdi mdi-chevron-left",
          active: false,
        },
      ],
      resources: [
        {
          title: "Resources",
          items: [
            {
              title: "Articles",
              link: "/spanish-learning-articles",
            },
            {
              title: "EBooks",
              link: "/spanish-learning-ebooks",
            },
            {
              title: "Events",
              link: "/comligo-spanish-events",
            },
            {
              title: "Case studies",
              link: "/spanish-case-studies",
            },
          ],
          link: "",
          icon: "mdi mdi-chevron-left",
          active: false,
        },
      ],
      individuals: [
        {
          title: "Individuals",
          items: [
            {
              title: "For Professionals",
              link: "/for-professionals",
            },
            {
              title: "For Young Learners",
              link: "/for-parents",
            },
            {
              title: "For Heritage Learners",
              link: "/for-heritage-speakers",
            },
            {
              title: "For Leisure & Travel",
              link: "/for-individuals",
            },
          ],
          link: "",
          icon: "mdi mdi-chevron-left",
          active: false,
        },
      ],
    };
  },
  methods: {
    openLink(link) {
      window
        .open(
          `${
            link.includes("mail")
              ? ""
              : link.includes("https")
              ? ""
              : "https://"
          }${link}`,
          "_blank"
        )
        .focus();
    },
  },
};
</script>

<style></style>
